import { Button, Dropdown, Input } from 'antd';
import { useState } from 'react';
import { SketchPicker } from 'react-color';

export default function InputColor({ onChange, value }) {
    const [internalColor, setInternalColor] = useState(value);
    const triggerChange = (changedValue) => {
        onChange?.(changedValue);
    };
    function rgbaToHex(r, g, b, a) {
        r = Math.round(r);
        g = Math.round(g);
        b = Math.round(b);
        a = Math.round(a * 255);
        return (
            '#' +
            ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1) +
            a.toString(16).padStart(2, '0')
        );
    }
    const handleChange = (color) => {
        const hexConvert = rgbaToHex(
            color.rgb.r,
            color.rgb.g,
            color.rgb.b,
            color.rgb.a
        );
        setInternalColor(hexConvert?.toUpperCase());
        triggerChange(hexConvert?.toUpperCase());
    };
    const overlay = (
        <div>
            <SketchPicker
                color={value || internalColor}
                enableAlpha={false}
                onChange={handleChange}
            />
        </div>
    );
    return (
        <span className="flex justify-between space-x-4">
            <Dropdown trigger={['click']} overlay={overlay}>
                <Button
                    className="w-10 h-10"
                    size="large"
                    style={{ background: value || internalColor }}
                >
                    {' '}
                </Button>
            </Dropdown>
            <Input
                size="large"
                value={value || internalColor}
                onChange={(e) => {
                    triggerChange(e.target.value);
                    setInternalColor(e.target.value);
                }}
            />
        </span>
    );
}
